import React from 'react';
import WrappedBase from './WrappedBase';

import QuickShopModalTrigger from '../containers/QuickShopModalTrigger';

export default class QuickShopModalTriggerWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <QuickShopModalTrigger {...this.props} />
      </WrappedBase>
    );
  }
}
